module.exports = __webpack_public_path__ + "static/img/visa.1db4869c.svg";